export default __webpack_public_path__ + "static/media/chata3.62958fad.jpg";